module.exports = __webpack_public_path__ + "static/media/MICHELL GYRO SE.d6858045.png";